import React from "react"
import ContentLoader from "react-content-loader";

const ProfileCard = (props) => {
    return(
        <ContentLoader
            // speed={1}
            width={'100%'}
            height={120}
            viewBox="0 0 100% 120"
            backgroundColor="#f3f3f3"
            foregroundColor="#ecebeb"
            {...props}
            >
            <rect x="10" y="230" rx="0" ry="0" width="416" height="2" />
            <circle cx="85" cy="55" r="42" />
            <rect x="145" y="40" rx="0" ry="0" width="120" height="10" />    
            <rect x="145" y="60" rx="0" ry="0" width="120" height="10" />
            {/* <rect x="145" y="80" rx="0" ry="0" width="120" height="5" /> */}
            <rect x="145" y="90" rx="0" ry="0" width="120" height="5" />
            <rect x="50%" y="15" rx="0" ry="0" width="45%" height="25" />
            {/* <rect x="55" y="135" rx="0" ry="0" width="30" height="12" />
            <rect x="30" y="150" rx="0" ry="0" width="92" height="9" />
            <rect x="265" y="135" rx="0" ry="0" width="30" height="12" />
            <rect x="231" y="150" rx="0" ry="0" width="92" height="9" /> */}
            {/* <rect x="98" y="130" rx="0" ry="0" width="160" height="9" /> */}
            
            {/* <rect x="34" y="180" rx="0" ry="0" width="285" height="35" /> */}
            {/* <rect x="106" y="324" rx="0" ry="0" width="146" height="51" /> */}
            </ContentLoader>
    )
}
ProfileCard.metadata = {
    name: 'DaniloWoz',
    github: 'DaniloWoz',
    description: 'Simple Article',
    filename: 'ProfileCard',
  }
export default ProfileCard